import { render, staticRenderFns } from "./GearManager.vue?vue&type=template&id=a8134632&scoped=true&"
import script from "./GearManager.vue?vue&type=script&lang=js&"
export * from "./GearManager.vue?vue&type=script&lang=js&"
import style0 from "./GearManager.vue?vue&type=style&index=0&id=a8134632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8134632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
